import { Link } from "react-router-dom";

import { categoryColor } from "../lib/colors";
import { galleryProjects } from "../lib/projects";

export function WorkGrid() {
  return (
    <section className="work" id="work">
      <div className="work__head" data-reveal>
        <span className="eyebrow">Selected work — 2020 to now</span>
        <h2>
          A few things I&rsquo;ve
          <br />
          <span className="hl">worked on.</span>
        </h2>
      </div>

      <div className="work__grid">
        {galleryProjects.map((project, index) => (
          <Link
            to={`/work/${project.id}`}
            className={`card ${index % 3 === 0 ? "card--wide" : ""}`}
            key={project.id}
            data-reveal
            style={
              {
                "--chip": categoryColor[project.category],
              } as React.CSSProperties
            }
            data-cursor="view"
          >
            <div className="card__media">
              <img
                src={project.image}
                alt={`${project.name} preview`}
                loading="lazy"
              />
              <span className="card__tag">{project.category}</span>
            </div>
            <div className="card__meta">
              <div className="card__row">
                <h3 className="card__name">{project.name}</h3>
                <span className="card__year">{project.year}</span>
              </div>
              <p className="card__blurb">{project.blurb}</p>
              <span className="card__role">
                {project.role}
                <i aria-hidden="true">↗</i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
